/**
 * Standalone size sort data loader (no ES modules)
 * Populates window.theme.sizeSortData
 */
(function () {
  "use strict";

  // Size sort map data from TypeScript source
  const SIZE_SORT_MAP = [
    { sizeText: "ONE", sizeLabel: "One", sortOrder: "-010" },
    { sizeText: "BIG", sizeLabel: "BIG", sortOrder: "-009" },
    { sizeText: "AS2", sizeLabel: "XXS", sortOrder: "-001" },
    { sizeText: "ASS", sizeLabel: "XS/S", sortOrder: "000" },
    { sizeText: "AXS", sizeLabel: "XS", sortOrder: "000" },
    { sizeText: "ASM", sizeLabel: "S", sortOrder: "001" },
    { sizeText: "ASD", sizeLabel: "S/M", sortOrder: "002" },
    { sizeText: "AMD", sizeLabel: "M", sortOrder: "003" },
    { sizeText: "AML", sizeLabel: "M/L", sortOrder: "003" },
    { sizeText: "ALG", sizeLabel: "L", sortOrder: "004" },
    { sizeText: "ALX", sizeLabel: "L/XL", sortOrder: "004" },
    { sizeText: "AXL", sizeLabel: "XL", sortOrder: "004" },
    { sizeText: "A2X", sizeLabel: "2XL", sortOrder: "005" },
    { sizeText: "A3X", sizeLabel: "3XL", sortOrder: "006" },
    { sizeText: "A4X", sizeLabel: "4XL", sortOrder: "007" },
    { sizeText: "A5X", sizeLabel: "5XL", sortOrder: "008" },
    { sizeText: "A6X", sizeLabel: "6XL", sortOrder: "009" },
    { sizeText: "WXS", sizeLabel: "XS", sortOrder: "010" },
    { sizeText: "WSM", sizeLabel: "S", sortOrder: "011" },
    { sizeText: "WSD", sizeLabel: "S-M", sortOrder: "012" },
    { sizeText: "WMD", sizeLabel: "M", sortOrder: "013" },
    { sizeText: "WLG", sizeLabel: "L", sortOrder: "014" },
    { sizeText: "WLX", sizeLabel: "L-XL", sortOrder: "015" },
    { sizeText: "WXL", sizeLabel: "XL", sortOrder: "016" },
    { sizeText: "W2X", sizeLabel: "2XL", sortOrder: "017" },
    { sizeText: "W23", sizeLabel: "2X-3X", sortOrder: "018" },
    { sizeText: "W3X", sizeLabel: "3XL", sortOrder: "019" },
    { sizeText: "W4X", sizeLabel: "4XL", sortOrder: "020" },
    { sizeText: "W5X", sizeLabel: "5XL", sortOrder: "021" },
    { sizeText: "TLG", sizeLabel: "TLG", sortOrder: "033" },
    { sizeText: "TXL", sizeLabel: "TXL", sortOrder: "034" },
    { sizeText: "T2X", sizeLabel: "T2XL", sortOrder: "035" },
    { sizeText: "T3X", sizeLabel: "T3XL", sortOrder: "036" },
    { sizeText: "Y2S", sizeLabel: "XXS", sortOrder: "050" },
    { sizeText: "YXS", sizeLabel: "XS", sortOrder: "051" },
    { sizeText: "YSM", sizeLabel: "S", sortOrder: "052" },
    { sizeText: "YMD", sizeLabel: "M", sortOrder: "053" },
    { sizeText: "YLG", sizeLabel: "L", sortOrder: "054" },
    { sizeText: "YXL", sizeLabel: "XL", sortOrder: "055" },
    { sizeText: "INB", sizeLabel: "Newborn", sortOrder: "060" },
    { sizeText: "I06", sizeLabel: "6 mo", sortOrder: "061" },
    { sizeText: "I12", sizeLabel: "12 mo", sortOrder: "062" },
    { sizeText: "I18", sizeLabel: "18 mo", sortOrder: "063" },
    { sizeText: "I24", sizeLabel: "24 mo", sortOrder: "064" },
    { sizeText: "G2S", sizeLabel: "XXS", sortOrder: "070" },
    { sizeText: "GXS", sizeLabel: "XS", sortOrder: "071" },
    { sizeText: "GSM", sizeLabel: "S", sortOrder: "072" },
    { sizeText: "GMD", sizeLabel: "M", sortOrder: "073" },
    { sizeText: "GLG", sizeLabel: "L", sortOrder: "074" },
    { sizeText: "GXL", sizeLabel: "XL", sortOrder: "075" },
    { sizeText: "T2T", sizeLabel: "2T", sortOrder: "092" },
    { sizeText: "T34", sizeLabel: "3-4T", sortOrder: "093" },
    { sizeText: "T3T", sizeLabel: "3T", sortOrder: "093" },
    { sizeText: "T4T", sizeLabel: "4T", sortOrder: "094" },
    { sizeText: "T56", sizeLabel: "5-6T", sortOrder: "095" },
    { sizeText: "T5T", sizeLabel: "5T", sortOrder: "095" },
    { sizeText: "T6T", sizeLabel: "6T", sortOrder: "096" },
    { sizeText: "T7T", sizeLabel: "7T", sortOrder: "096" },
    { sizeText: "PXS", sizeLabel: "XS", sortOrder: "110" },
    { sizeText: "PSM", sizeLabel: "S", sortOrder: "111" },
    { sizeText: "PMD", sizeLabel: "M", sortOrder: "112" },
    { sizeText: "PLG", sizeLabel: "L", sortOrder: "113" },
    { sizeText: "PXL", sizeLabel: "XL", sortOrder: "114" },
    { sizeText: "P2X", sizeLabel: "2X", sortOrder: "115" },
    { sizeText: "P3X", sizeLabel: "3X", sortOrder: "116" },
    { sizeText: "P30", sizeLabel: "30", sortOrder: "150" },
    { sizeText: "P32", sizeLabel: "32", sortOrder: "152" },
    { sizeText: "P34", sizeLabel: "34", sortOrder: "154" },
    { sizeText: "P36", sizeLabel: "36", sortOrder: "156" },
    { sizeText: "P38", sizeLabel: "38", sortOrder: "158" },
    { sizeText: "P40", sizeLabel: "40", sortOrder: "160" },
  ];

  // Ensure window.theme exists
  if (!window.theme) {
    window.theme = {};
  }

  // Populate global variable
  window.theme.sizeSortData = SIZE_SORT_MAP;
  console.log(
    "Size sort data loaded from standalone script:",
    SIZE_SORT_MAP.length,
    "size mappings",
  );
})();
